import React, { createContext, useState, useEffect, useContext } from 'react';

// Create context
const DarkModeContext = createContext();

// Custom hook to use dark mode
export const useDarkMode = () => {
  return useContext(DarkModeContext);
};

// Provider component
export const DarkModeProvider = ({ children }) => {
  // Check for saved preference or system preference
  const getInitialMode = () => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode) {
      return JSON.parse(savedMode);
    }
    // Check for system preference
    return window.matchMedia && 
      window.matchMedia('(prefers-color-scheme: dark)').matches;
  };

  const [darkMode, setDarkMode] = useState(getInitialMode);

  // Toggle dark mode
  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  // Update localStorage and apply class when darkMode changes
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.body.setAttribute('data-theme', 'dark'); // Also set on body for page-specific styling
    } else {
      document.documentElement.removeAttribute('data-theme');
      document.body.removeAttribute('data-theme'); // Remove from body as well
    }
  }, [darkMode]);

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};
